export default __webpack_public_path__ + "static/media/news30.dd4e8e1e.jpg";